import {
  ASK_RELAY_HUB_PATH,
  USER_RELAY_HUB_PATH,
  WORKSPACE_RELAY_HUB_PATH,
} from './SignalR.constants';

/** Hub name → path/url from environment variables. */
export const parseHubConfigs = (): Map<string, string> => {
  const hubs = new Map<string, string>();

  if (ASK_RELAY_HUB_PATH) {
    hubs.set('askRelayHub', ASK_RELAY_HUB_PATH);
  }
  if (USER_RELAY_HUB_PATH) {
    hubs.set('userRelayHub', USER_RELAY_HUB_PATH);
  }
  if (WORKSPACE_RELAY_HUB_PATH) {
    hubs.set('workspaceRelayHub', WORKSPACE_RELAY_HUB_PATH);
  }

  if (hubs.size === 0) {
    console.warn(
      '⚠️ No SignalR hubs configured. Please set environment variables:\n' +
        '  - VITE_SIGNALR_HUB_PATH_ASK_RELAY_HUB=/askRelayHub\n' +
        '  - VITE_SIGNALR_HUB_PATH_USER_RELAY_HUB=/userRelayHub\n' +
        '  - VITE_SIGNALR_HUB_PATH_WORKSPACE_RELAY_HUB=/workspaceRelayHub',
    );
  }

  return hubs;
};
